import fetch from "@/utils/fetch";
// import { getToken } from "@/utils/auth";
import { stringify } from "qs";

const API_BASE = window.SERVERAPI.API_BASE;

// 待办需求-人员
export function GetWaitDoneDemandManagementUser(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/GetWaitDoneDemandManagementUser",
    method: "get",
    params
  });
}

// 待办需求-项目
export function GetWaitDoneDemandManagementProjectTotal(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/GetWaitDoneDemandManagementProjectTotal",
    method: "get",
    params
  });
}

// 待办需求-新增续约项目
export function GetWaitDoneDemandManagementProject(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/GetWaitDoneDemandManagementProject",
    method: "get",
    params
  });
}

// 获取客户需求分页
export function GetCustomerDemandManagementPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/GetCustomerDemandManagementPageList",
    method: "get",
    params
  });
}

// 根据主键ID获取
export function GeDemandManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "P_DemandManagement/GeDemandManagement",
    method: "get",
    params
  });
}

// 获取合同基本详情
export function GetProjectManagementBaseDetails(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetProjectManagementBaseDetails",
    method: "get",
    params
  });
}

// 客户需求沟通分页
export function GetDemandCommunicationManagementPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandCommunicationManagement/GetDemandCommunicationManagementPageList",
    method: "get",
    params
  });
}

// 删除成本批次
export function DeleteDemandCommunicationManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandCommunicationManagement/DeleteDemandCommunicationManagement",
    method: "delete",
    params
  });
}

export function AddDemandCommunicationManagement(data) {
  // 把data转换成表单数据
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return fetch({
    body: formData,
    baseURL: API_BASE,
    url: "/P_DemandCommunicationManagement/AddDemandCommunicationManagement",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: stringify(data)
  });
}

// 客户需求附件
export function GetDemandAdjunctManagementPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandAdjunctManagement/GetDemandAdjunctManagementPageList",
    method: "get",
    params
  });
}

// 接收需求
export function ReceiveDemandManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/ReceiveDemandManagement",
    method: "post",
    params
  });
}

// 关闭需求
export function CloseDemandManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/CloseDemandManagement",
    method: "post",
    params
  });
}

// 需求添加附件
export function AddDemandAdjunctManagement(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandAdjunctManagement/AddDemandAdjunctManagement",
    method: "post",
    data
  });
}

// 项目需求中的接口
// 接收项目-人员
export function GetReceiveProjectUser(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetReceiveProjectUser",
    method: "get",
    params
  });
}

// 接收项目-人员（新）
export function GetReceiveProjectUserNew(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetReceiveProjectUserNew",
    method: "get",
    params
  });
}

// 接收项目-项目
export function GetReceiveProjectTotal(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetReceiveProjectTotal",
    method: "get",
    params
  });
}
// 接收项目-项目（新）
export function GetReceiveProjectNew(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetReceiveProjectNew",
    method: "get",
    params
  });
}

// 接收项目-新增/续约项目
export function GetReceiveProject(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetReceiveProject",
    method: "get",
    params
  });
}
// 根据部门ID（多个）返回用户
export function GetUserByDepartList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/User/GetUserByDepartList",
    method: "get",
    params
  });
}

// 根据用户获取岗位
export function GetJobByUser(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_UserJob/GetJobByUser",
    method: "get",
    params
  });
}

// 获取岗位下拉框
export function GetListByType(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/Dictionary/GetListByType",
    method: "get",
    params
  });
}

// 接收项目---项目移交
export function HandoverProject(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/HandoverProject",
    method: "get",
    params
  });
}

// 带分解需求---需求移交
export function HandoverDemandManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/HandoverDemandManagement",
    method: "get",
    params
  });
}

// 带分解需求---需求移交到其他项目
export function HandoverDemandManagementToProject(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/HandoverDemandManagementToProject",
    method: "get",
    params
  });
}

// 新建客户需求
export function AddDemandManagement(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/AddDemandManagement",
    method: "post",
    data
  });
}

// 全文检索
export function GetFullTextSearch(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/FullTextSearch/GetFullTextSearch",
    method: "get",
    params
  });
}

// 接收项目---项目(根据项目获取所有接收的新增/续约项目)
export function GetAllReceiveProjectByProjectTotal(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/ProjectManagement/GetAllReceiveProjectByProjectTotal",
    method: "get",
    params
  });
}

// 根据权限获取未完成的需求
export function GetAllNotFinishedDemandManagementNew(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/GetAllNotFinishedDemandManagementNew",
    method: "get",
    params
  });
}

// 获取登录人员待办需求
export function GetWaitDoneDemandManagementList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandManagement/GetWaitDoneDemandManagementList",
    method: "get",
    params
  });
}

// 需求沟通评论中的图片上传
export function AddDemandAdjunctManagementUploadImg(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_DemandCommunicationManagement/AddDemandAdjunctManagementUploadImg",
    method: "post",
    data
  });
}
